module.exports = __webpack_public_path__ + "img/ai.6b071968.png";